import {TextField} from '@material-ui/core'
import {TextFieldProps} from '@material-ui/core/TextField/TextField'
import React from 'react'

import {useHelperClasses, useInputClasses, useLabelClasses, useMenuListClasses, useSelectClasses} from './classes'

export type Props = TextFieldProps

const Input: React.FC<React.PropsWithChildren<Props>> = props => {
  const {
    placeholder,
    inputProps,
    InputProps: BaseInputProps,
    InputLabelProps: BaseInputLabelProps,
    FormHelperTextProps: BaseFormHelperTextProps,
    ...restProps
  } = props

  // почему-то TS ругается если не выносить в переменную
  const InputProps: TextFieldProps['InputProps'] = {
    classes: useInputClasses(),
    disableUnderline: true,
    ...BaseInputProps,
  }
  const InputLabelProps: TextFieldProps['InputLabelProps'] = {
    classes: useLabelClasses(),
    ...BaseInputLabelProps,
  }
  const FormHelperTextProps: TextFieldProps['FormHelperTextProps'] = {
    classes: useHelperClasses(),
    ...BaseFormHelperTextProps,
  }
  const SelectProps: TextFieldProps['SelectProps'] = {
    classes: useSelectClasses(),
    inputProps: {
      MenuProps: {
        classes: useMenuListClasses(),
      },
    },
  }

  return (
    <TextField
      FormHelperTextProps={FormHelperTextProps}
      InputLabelProps={InputLabelProps}
      inputProps={{
        autoComplete: '__disable-autocomplete',
        ...inputProps,
      }}
      InputProps={InputProps}
      label={placeholder}
      SelectProps={SelectProps}
      variant="filled"
      {...restProps}
    />
  )
}

export default Input
